export default function PhoneIcon() {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.7388 14.4138C18.5716 15.6841 17.9477 16.8502 16.9837 17.6942C16.0196 18.5382 14.7813 19.0023 13.5 19.0001C6.05626 19.0001 8.4831e-06 12.9438 8.4831e-06 5.50005C-0.00228837 4.21876 0.461903 2.98045 1.30588 2.01639C2.14986 1.05234 3.31592 0.428467 4.58626 0.261304C4.9075 0.22208 5.2328 0.2878 5.51362 0.448653C5.79444 0.609506 6.0157 0.856865 6.14438 1.1538L8.12438 5.57412V5.58537C8.2229 5.81267 8.26359 6.06083 8.24282 6.30769C8.22204 6.55455 8.14044 6.79242 8.00532 7.00005C7.98845 7.02537 7.97063 7.0488 7.95188 7.07224L6.00001 9.38599C6.7022 10.8129 8.1947 12.2922 9.64032 12.9963L11.9222 11.0547C11.9446 11.0359 11.9681 11.0184 11.9925 11.0022C12.2 10.8639 12.4387 10.7794 12.687 10.7565C12.9353 10.7336 13.1854 10.7729 13.4147 10.871L13.4269 10.8766L17.8434 12.8557C18.1409 12.9839 18.3889 13.205 18.5503 13.4858C18.7116 13.7667 18.7778 14.0922 18.7388 14.4138Z"
        fill="url(#paint0_linear_3116_3112)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3116_3112"
          x1="3.5"
          y1="2.5"
          x2="10.5"
          y2="25"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F8AD1F" />
          <stop offset="1" stopColor="#CA8945" />
        </linearGradient>
      </defs>
    </svg>
  );
}
